import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Lock, Mail } from 'lucide-react';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'var(--bg-page)',
        backgroundImage: 'url(https://images.unsplash.com/photo-1663497653290-1b8f327096f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxtaW5pbWFsJTIwYWJzdHJhY3QlMjBnZW9tZXRyaWMlMjBiYWNrZ3JvdW5kJTIwd2hpdGUlMjBncmV5fGVufDB8fHx8MTc3NTY0NDQ2N3ww&ixlib=rb-4.1.0&q=85)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
      data-testid="login-page"
    >
      <div
        className="card"
        style={{
          width: '100%',
          maxWidth: '400px',
          margin: '0 16px',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
        <img src='https://server.dweb.co.in/img/cpp.png' alt='logo' style={{width:'60%', margin:'auto'}} />
          <p style={{ color: 'var(--text-secondary)', marginTop: '8px', fontSize: '14px' }}>
            Sign in to your account
          </p>
        </div>

        {error && (
          <div
            style={{
              padding: '12px',
              backgroundColor: '#FEE2E2',
              border: '1px solid #F87171',
              borderRadius: '4px',
              color: '#991B1B',
              marginBottom: '20px',
              fontSize: '13px',
            }}
            data-testid="login-error"
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} data-testid="login-form">
          <div className="form-group">
            <label className="form-label" htmlFor="email">
              <Mail size={14} style={{ display: 'inline', marginRight: '4px' }} />
              Email
            </label>
            <input
              id="email"
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="admin@erp.com"
              data-testid="email-input"
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="password">
              <Lock size={14} style={{ display: 'inline', marginRight: '4px' }} />
              Password
            </label>
            <input
              id="password"
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
              data-testid="password-input"
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', marginTop: '8px' }}
            disabled={loading}
            data-testid="login-submit-btn"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        {/* <div
          style={{
            marginTop: '24px',
            padding: '16px',
            backgroundColor: 'var(--bg-surface-alt)',
            borderRadius: '4px',
            fontSize: '12px',
          }}
        >
          <div style={{ fontWeight: 600, marginBottom: '8px' }}>Test Credentials:</div>
          <div>Admin: admin@erp.com / Admin@123</div>
          <div>Manager: manager@erp.com / Manager@123</div>
          <div>Operator: operator@erp.com / Operator@123</div>
        </div> */}
      </div>
    </div>
  );
};

export default Login;
